import type { SerializedConstructor } from '@langchain/core/load/serializable';

import { parseLangSmithParamsFromRun } from '@/utils/langsmith-params';

import type { ManifestPreviewProps } from '../../Manifest.utils';

export function useAzureOpenAIModelAndProvider(
  props: ManifestPreviewProps<SerializedConstructor>
) {
  const id = props.value.id.at(-1) ?? '';
  const deploymentName = props.value.kwargs['deployment_name'] ?? '';

  if (props.variant === 'line') {
    return {
      model: deploymentName,
      provider: id,
    };
  }

  return null;
}

export function inferAzureOpenAIManifestFromRun(
  params: ReturnType<typeof parseLangSmithParamsFromRun> | null
): SerializedConstructor | null {
  if (params?.ls_provider !== 'azure' || params?.ls_model_type !== 'text') {
    return null;
  }

  return {
    lc: 1,
    type: 'constructor',
    id: ['langchain', 'llms', 'openai', 'AzureOpenAI'],
    kwargs: {
      model: params.ls_model_name,
      temperature: params.ls_temperature,
      max_tokens: params.ls_max_tokens,
    },
  };
}
